import { defineStore } from 'pinia';

export const useTermsStore = defineStore('terms', {
	state: () => {
		return {
			terms: []
		}
	},
	getters: {
		getTermValueByKey: (state) => {
			return (text, fallback) => {
				let terms = JSON.parse(localStorage.getItem('terms'));

				if (!terms) {
					return text;
				}

				// Create a regular expression to match whole words only, by surrounding each key with word boundaries (\b)
				terms.forEach((t) => {
					const regex = new RegExp(`\\b${t.key}\\b`, 'g');
					text = text.replace(regex, t.value);
				});

				return text.toUpperCase();
			}
		}
	},

	actions: {}
});